import { useState } from "react";
import { ArrowUp } from "lucide-react";

export const ChatInput = ({ onSend, disabled }) => {
  const [value, setValue] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const text = value.trim();
    if (!text || disabled) return;
    onSend(text);
    setValue("");
  };

  return (
    <div className="sticky bottom-0 bg-[#09101a]/85 backdrop-blur-xl border-t border-[#1e293b] p-4">
      <form
        data-testid="chat-form"
        onSubmit={submit}
        className="flex items-end gap-2 rounded-full border border-[#1e293b] bg-[#121b29] pl-5 pr-2 py-2 overflow-hidden focus-within:border-[#0cb0b5] focus-within:ring-2 focus-within:ring-[#0cb0b5]/40 transition-all duration-200"
      >
        <textarea
          data-testid="chat-input-field"
          rows={1}
          value={value}
          disabled={disabled}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              submit(e);
            }
          }}
          placeholder="Ask me anything"
          className="flex-1 resize-none bg-transparent text-[15px] text-white placeholder:text-slate-500 outline-none py-2 max-h-32 nesan-scroll disabled:opacity-50"
        />
        <button
          type="submit"
          data-testid="chat-send-button"
          aria-label="Send message"
          disabled={disabled || !value.trim()}
          className="shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-[#0cb0b5] text-white hover:bg-[#088c91] transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0cb0b5]"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
      </form>
      <p
        data-testid="chat-disclaimer"
        className="text-[11px] tracking-wide text-slate-500 mt-3 text-center"
      >
        This AI learned everything from Nesan. Including deflecting hard questions to Nesan
      </p>
    </div>
  );
};
